var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function IconVideo(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M1 4.75C1 3.784 1.784 3 2.75 3h14c.966 0 1.75.784 1.75 1.75v10a1.75 1.75 0 01-1.75 1.75h-14A1.75 1.75 0 011 14.75v-10zm1.75-.25a.25.25 0 00-.25.25v10c0 .138.112.25.25.25h14a.25.25 0 00.25-.25v-10a.25.25 0 00-.25-.25h-14z", clipRule: "evenodd" }),
        React.createElement("path", { fillRule: "evenodd", d: "M14.5 9.75a.75.75 0 01-.375.65l-6 3.464A.75.75 0 017 13.214V6.286a.75.75 0 011.125-.65l6 3.464a.75.75 0 01.375.65zm-6-2.165v4.33l3.75-2.165L8.5 7.585z", clipRule: "evenodd" })));
}
export default IconVideo;
